import React from 'react';
import PropTypes from 'prop-types';
import { SidePanel } from '../SidePanel';

export const MainContainer = ({
	side,
	main,
	title,
	context,
	style
}) => side ? (
		<>
			<div className="page-topic" style={style}>
				<div className="page-headline">
					<h1 className="page-title">{title}</h1>
					<p className="page-description">{context}</p>
				</div>
				<div className="page-content container-filled">
					{main}
				</div>
			</div>
			<SidePanel>
				{side}
			</SidePanel>
		</>
) : main

MainContainer.propTypes = {
	side: PropTypes.element,
	main: PropTypes.element,
	title: PropTypes.string,
	context: PropTypes.string,
	style: PropTypes.object
};
